export const getBrowserName = () => {
    let userAgentString = navigator.userAgent;
    if (
        userAgentString.indexOf('Chrome') > -1 &&
        !(userAgentString.indexOf('OP') > -1)
    )
        return 'chrome';
    if (userAgentString.indexOf('Firefox') > -1) return 'firefox';
    if (
        userAgentString.indexOf('Safari') > -1 &&
        !(userAgentString.indexOf('OP') > -1)
    )
        return 'safari';
    if (
        userAgentString.indexOf('MSIE') > -1 ||
        userAgentString.indexOf('rv:') > -1
    )
        return 'internet_Explorer';
    if (userAgentString.indexOf('OP') > -1) return 'opera';
    return 'notKnown';
};

export const getDeviceType = () => {
    return 'web';
};
